<template lang="pug">
.v-hero-slider.hero-slider
	v-loader(:loading="loading")
	button.hero-slider__arrow.hero-slider__arrow--prev(type="button" ref="prev" aria-label="Предыдущий слайд")
		v-svg-icon.hero-slider__icon(icon="slide-left")
	button.hero-slider__arrow.hero-slider__arrow--next(type="button" ref="next" aria-label="Следующий слайд")
		v-svg-icon.hero-slider__icon(icon="slide-right")
	v-swiper-slider(v-if="slider && slider.slides && slider.slides.length"
			:options="options"
			:navigation="navigation"
			@swiper="onSwiper")
		swiper-slide(v-for="(slide, index) in slider.slides" :key="index")
			v-hero-block(:data-source="slide")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import uniqueId from '../scripts/helpers/uniqueId.js';
import { SwiperSlide } from 'swiper/vue';

export default {
	components: {
		SwiperSlide
	},

	mixins: [
		sourceMixin
	],

	data() {
		return {
			slider: {},
			uniqueId: uniqueId('swiper-'),
			options: {
				slidesPerView: 1,
				spaceBetween: 0,
				loop: true
			},
			navigation: false
		};
	},

	methods: {
		onSwiper() {
			this.navigation = {
				prevEl: this.$refs['prev'],
				nextEl: this.$refs['next']
			}
		},

		dataSet(data) {
			this.slider = data;
		}
	}
};
</script>